import { NgModule } from '@angular/core'
import { VideoFormComponent } from './video-form.component'
import { CommonModule } from '@angular/common'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { MatInputModule } from '@angular/material/input'
import { EditorModule } from '@tinymce/tinymce-angular'
import { DatetimePickerModule } from '../../datetime-picker/datetime-picker.module'
import { BsDropdownModule } from 'ngx-bootstrap/dropdown'
import { PopoverModule } from 'ngx-bootstrap/popover'
import { NgxFileDropModule } from 'ngx-file-drop'
import { PluralizeModule } from '../../../pipes/pluralize/pluralize.module'
import { PopCardModule } from '../../pop-card/pop-card.module'
import { OutsideClickModule } from '../../../directives/outside-click/outside-click.module'
import { AccordionFadeModule } from '../../accordion-fade/accordion-fade.module'
import { KeywordMutations } from '../../../graphql/mutations/keyword.mutations'
import { MatAutocompleteModule } from '@angular/material/autocomplete'
import { SourceContentForm } from './components/source-content-form.component'
import { MatSelectModule } from '@angular/material/select'
import { MatIconModule } from '@angular/material/icon'
import { ColorPickerModule } from 'ngx-color-picker'
import { ActivateRequestModal } from './activate-request-modal.component'
import { ModalModule } from '../../modal/modal.module'

@NgModule({
  declarations: [
    VideoFormComponent,
    SourceContentForm,
    ActivateRequestModal
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatInputModule,
    MatSelectModule,
    MatIconModule,
    MatAutocompleteModule,
    EditorModule,
    DatetimePickerModule,
    BsDropdownModule,
    PopoverModule,
    NgxFileDropModule,
    PluralizeModule,
    PopCardModule,
    OutsideClickModule,
    AccordionFadeModule,
    ColorPickerModule,
    ModalModule
  ],
  exports: [
    VideoFormComponent,
    SourceContentForm
  ],
  providers: [
    KeywordMutations
  ]
})
export class VideoFormModule {}
